import Cookies from "js-cookie";
import { XSRF_TOKEN } from "src/config/axios";
import { getAppEnvironment } from "./dataParsing";

const getXSRFCookieName = (): string => {
  const environment = getAppEnvironment();

  if (environment && environment.length) {
    return `${XSRF_TOKEN}-${environment}`;
  }

  return XSRF_TOKEN;
};

// eslint-disable-next-line import/prefer-default-export
export const getXSRFCookieVal = (): string => {
  const cookieName = getXSRFCookieName();

  const XSRFCookie = Cookies.get(cookieName);

  return XSRFCookie ?? "";
};
